declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { HCPService } from '../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { v4 as uuidv4 } from 'uuid';
//import { NgxMaskModule } from 'ngx-mask';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../services/datetime.service';
//import './profilesteps.js';
//declare var mess1: any;
//declare var stepObject: any;
//declare var pSteps: any;
//declare var webGlObject: any;

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';


import { PrintService } from '../../../../../../src/app/ncs/services/print.service';

import { NgbAddbilladv } from '../opbilling/modal/addbilladv.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbSearchPatientModal } from '../follow up/counsellingregistry/modal/searchpatient.modal';
import { NgbNewCycleModal } from '../ivf/ivfdashboard/newcycle.modal';
import { NgbUpdateCycleStatusModal } from '../ivf/ivfdashboard/updatecyclestatus.modal';
import { ServiceCategoryPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbAOEServiceModal } from './aoeservice.modal';
import { NgbCategoryChangeModal } from './categorychange.modal';
import { AdmissionsByCodeController, SaveServiceToAdmission, GenericProcPostRequest, S_Methods, AdmissionServicesController, GetAdmissionServices, SaveAdmissionTreatmentCategory, GenericParams, FTV, DeletedAdmissionServiceRequest, AdmissionsHeader2, SaveAdmissionBillDetails, SaveAdmissionLabDetails } from '../../../../../../src/app/ncs/models/actor/actor';
import { ServicesByCategoryCodeController } from '../../../../../../src/app/ncs/models/actor/actor';
import { ServicesByCategoryCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AdmissionServiceDetail } from '../../../../../../src/app/ncs/models/actor/actor';
import { NgbAOEditServiceModal } from './aoeditservice.modal';

@Component({
  selector: 'opserviceshistory',
  templateUrl: './opserviceshistory.component.html',
  styleUrls: ['./opserviceshistory.component.scss']
})

export class OPServicesHistoryComponent implements OnInit {

  @Input() SelectedAdmission: AdmissionsByCodeController; 
  public isRequesting: boolean = false;  
  public ApiResData: ApiResponseModel;
  searchTitle: string;
  TodayDate = new Date();
  public UpdatedServiceDate: NgbDateStruct;
   
  constructor(private router: Router,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private hcpservice: HCPService, private actorservice: ActorService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter,
    private filter: ServiceCategoryPipe, private spinner: NgxSpinnerService,
    private tosterservice: NGXToastrService) {
    //stepObject.init();
  }
  CurrentSaveServiceToAdmission: SaveServiceToAdmission;
  CurrentSaveAdmissionTreatmentCategory: SaveAdmissionTreatmentCategory;
  ngOnInit() { 


    // if the admission is still open, hten load services
    // if discharge initiated or discharged patietn.. no need to load services...!
    this.LoadServicesByCategory();
    this.CurrentSaveServiceToAdmission = new SaveServiceToAdmission();
    this.CurrentSaveServiceToAdmission.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentSaveAdmissionTreatmentCategory = new SaveAdmissionTreatmentCategory();
    this.CurrentSaveAdmissionTreatmentCategory.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadDetailedAdmissionData();
    this.LoadAdmissionServices();
    this.UpdatedServiceDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.LoadTreatmentCategory();
  }
  AdmissionHeader2: AdmissionsHeader2; 
  LoadDetailedAdmissionData() {
    /// 101029
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    var getReq: GenericParams = new GenericParams();
    getReq.ConditionalOperator = 101029;
    getReq.Params = [
      new FTV('AdmissionNo', 'number', this.SelectedAdmission.AdmissionCode)
    ];
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101029;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          this.AdmissionHeader2 = JSON.parse(data)[0];
          //alert(this.AdmissionHeader2);
          //alert(this.AdmissionHeader2.IsDischargeInitiated);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  public TreatmentCategory: string;
    LoadTreatmentCategory() {
      var gReq: GenericProcPostRequest = new GenericProcPostRequest();
      var getReq: GenericParams = new GenericParams();
      getReq.ConditionalOperator = 101027;
      getReq.Params = [
        new FTV('AdmissionNo', 'number', this.SelectedAdmission.AdmissionCode)
      ];
      getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      var str = JSON.stringify(getReq);
      gReq.ConditionalOperator = 101027;
      gReq.QueryData = str;
      gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.actorservice.Save<GenericProcPostRequest>(
        gReq, S_Methods.GetGenericPost)
        .subscribe((result) => {

          this.ApiResData = result;
          if (!this.ApiResData.hasError) {
            var data: string = this.ApiResData.Result.join("");
            //alert(data);
            var trct = JSON.parse(data)[0].TreatmentCategory;
            this.TreatmentCategory = trct;
            //alert(trct);
            if (this.ApiResData.Result[0].length > 0) {
              //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
              this.stopRefreshing();
            }
            else {
              // alertFunctions.AlertParam("Invalid Operation...!");
              this.stopRefreshing();
            }
          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {
              alert(this.ApiResData.ErrorData);
            }
            else {
              this.stopRefreshing();
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            }
          }

        },
          (error) => {

            if (error == "401 - Unauthorized") {
              alertFunctions.AlertParamEr(error);

              this.stopRefreshing();
            }
            else {
              alertFunctions.AlertParamEr(error);

              this.stopRefreshing();
            }
          }
        );
    }
  CurrentAdmissionServicesController: AdmissionServicesController[];
  LoadAdmissionServices() {
    var getReq = new GetAdmissionServices();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101026;
    getReq.FacilityCode = AppData.Instance().SelectedBranchCode;
    getReq.AdmissionNo = this.SelectedAdmission.AdmissionCode;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101026;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentAdmissionServicesController = JSON.parse(data);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  CurrentServicesByCategoryCodeGetRequest: ServicesByCategoryCodeRequest;
  CurrentServicesByCategoryCodeController: ServicesByCategoryCodeController[];
  LoadServicesByCategory() {

    this.CurrentServicesByCategoryCodeGetRequest = new ServicesByCategoryCodeRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;
    this.CurrentServicesByCategoryCodeGetRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentServicesByCategoryCodeGetRequest.ServiceCategory = "0";
    this.CurrentServicesByCategoryCodeGetRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentServicesByCategoryCodeGetRequest.ConditionalOperator = 10;
    //this.CurrentServicesByCategoryCodeGetRequest.PrescriberCode = Presecribercode;
    this.CurrentServicesByCategoryCodeController = new Array<ServicesByCategoryCodeController>();
    this.pdata = this.CurrentServicesByCategoryCodeController;
    this.GetServicesByCategoryCodeController();

  }
  GetServicesByCategoryCodeController() {
    this.StartRefreshing();
    this.spinner.show();
    this.actorservice.GetServicesByCategoryCodeController(this.CurrentServicesByCategoryCodeGetRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentServicesByCategoryCodeController = this.ApiResData.Result;
          this.pdata = this.CurrentServicesByCategoryCodeController;

          this.stopRefreshing();
          this.spinner.hide();
        }
        else {
          this.stopRefreshing();
          this.spinner.hide();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
            this.spinner.hide();


          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
            this.spinner.hide();
          }
        }


      );

  }

  pdata: any[];// = this.data;
  listFilter: string;
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentServicesByCategoryCodeController,
          this.listFilter);
      }
    }
  }

  GenerateBill() {
    var saveReq = new SaveAdmissionBillDetails();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40200;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.AdmissionNo = this.SelectedAdmission.AdmissionCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40200;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          // then refresh
          this.LoadAdmissionServices();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  GenerateLabOrder() {
    var saveReq = new SaveAdmissionLabDetails();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40210;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.AdmissionNo = this.SelectedAdmission.AdmissionCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40210;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          // then refresh
          this.LoadAdmissionServices();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  AddServices(l: ServicesByCategoryCodeController) {

    var AdmissionService = new AdmissionServiceDetail();

    AdmissionService.ServiceName = l.ServiceName;
    AdmissionService.ServiceCode = l.Code;
    AdmissionService.AdmissionNo = this.SelectedAdmission.AdmissionCode;
    AdmissionService.AdmissionDate = this.SelectedAdmission.AdmissionDate;
    AdmissionService.CareUnit = this.SelectedAdmission.CareUnit;
    AdmissionService.BedLocation = this.SelectedAdmission.BedLocation;
    AdmissionService.PatientName = this.SelectedAdmission.PatientName;
    AdmissionService.TreatmentCategory = this.SelectedAdmission.TreatmentCategory;
    AdmissionService.PatientFormattedCode = this.SelectedAdmission.PatientFormattedCode;
    AdmissionService.ServiceDate = new Date();
    AdmissionService.BranchName = AppData.Instance().UserLoginDetails.FacilityName;
    AdmissionService.BranchCode = AppData.Instance().SelectedFacilityCode;

    const modalRef = this.modalService.open(NgbAOEServiceModal,
      {
        centered: true,
        backdrop: 'static',
        size: 'lg',
        keyboard: false

      })

    modalRef.componentInstance.AdmissionService = AdmissionService;
    modalRef.result.then((val: any) => {
      var str = 'Close click';
      if (val == str) {

      }
      else {
        var sad = val as AdmissionServiceDetail;
        this.AddServiceToAdmission(val);
      }      
      
    });
  
  }

    AddServiceToAdmission(val: AdmissionServiceDetail) {
      // save service to admission .. generic.. 40162
      var saveReq = new SaveServiceToAdmission();
      var gReq: GenericProcPostRequest = new GenericProcPostRequest();
      saveReq.ConditionalOperator = 40162;
      saveReq.BranchCode = AppData.Instance().SelectedBranchCode;
      saveReq.ProviderCode = val.ProviderCode;
      saveReq.ProviderName = val.ProviderName;
      saveReq.ServiceCode = val.ServiceCode;
      saveReq.ServiceName = val.ServiceName;
      saveReq.ServiceDate = val.ServiceDate;
      //alert(saveReq.ServiceDate);
      saveReq.Quantity = 1;
      saveReq.AdmissionNo = val.AdmissionNo;
      saveReq.AdmissionServiceItemID = uuidv4();
      saveReq.AdmissionServiceItemCode = 0;
      saveReq.TreatmentCategory = val.TreatmentCategory;
      saveReq.Remarks = val.Remarks;
      saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      var str = JSON.stringify(saveReq);
      gReq.ConditionalOperator = 40162;
      gReq.QueryData = str;
      gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.actorservice.Save<GenericProcPostRequest>(
        gReq, S_Methods.SaveGenericPost)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {

            //if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            // then refresh
            this.LoadAdmissionServices();
            //this.activeModal.close();
            //}
            //else {
            //alertFunctions.AlertParam("Invalid Operation...!");
            //this.stopRefreshing();
            //}
          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {
              alert(this.ApiResData.ErrorData);
            }
            else {
              this.stopRefreshing();
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            }
          }

        },
          (error) => {

            if (error == "401 - Unauthorized") {
              alertFunctions.AlertParamEr(error);

              this.stopRefreshing();
            }
            else {
              alertFunctions.AlertParamEr(error);

              this.stopRefreshing();
            }
          }
        );

  }

  EditServices(l: AdmissionServicesController) {

    var AdmissionService = new AdmissionServiceDetail();

    AdmissionService.ServiceName = l.Details;
    AdmissionService.ServiceCode = l.ServiceCode;
    AdmissionService.AdmissionNo = this.SelectedAdmission.AdmissionCode;
    AdmissionService.AdmissionDate = this.SelectedAdmission.AdmissionDate;
    AdmissionService.AdmissionServiceItemID = l.AdmissionServiceItemID;
    AdmissionService.AdmissionServiceItemCode = l.AdmissionServiceItemCode;
    AdmissionService.CareUnit = this.SelectedAdmission.CareUnit;
    AdmissionService.BedLocation = this.SelectedAdmission.BedLocation;
    AdmissionService.PatientName = this.SelectedAdmission.PatientName;
    AdmissionService.TreatmentCategory = l.TreatmentCategory;
    AdmissionService.PatientFormattedCode = this.SelectedAdmission.PatientFormattedCode;
    AdmissionService.ServiceDate = new Date(l.PlannedServiceDate);
    AdmissionService.BranchName = AppData.Instance().UserLoginDetails.FacilityName;
    AdmissionService.BranchCode = l.Facility;
    AdmissionService.Remarks = l.Remarks;
    AdmissionService.ProviderName = l.ProviderName;

    const modalRef = this.modalService.open(NgbAOEditServiceModal,
      {
        centered: true,
        backdrop: 'static',
        size: 'lg',
        keyboard: false

      })

    modalRef.componentInstance.AdmissionService = AdmissionService;
    modalRef.result.then((val:any) =>
    {
      var str = 'Close click';
      if (val == str) {

      }
      else {
        var sad = val as AdmissionServiceDetail;
        this.EditServiceToAdmission(val);
      }

    });

  }

  EditServiceToAdmission(val: AdmissionServiceDetail) {
    // save service to admission .. generic.. 40162
    var saveReq = new SaveServiceToAdmission();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40172;
    saveReq.BranchCode = val.BranchCode;
    saveReq.ProviderCode = val.ProviderCode;
    saveReq.ProviderName = val.ProviderName;
    saveReq.ServiceCode = val.ServiceCode;
    saveReq.ServiceName = val.ServiceName;
    saveReq.ServiceDate = val.ServiceDate;
    //alert(saveReq.ServiceDate);
    saveReq.Quantity = 1;
    saveReq.AdmissionNo = val.AdmissionNo;
    saveReq.AdmissionServiceItemID = val.AdmissionServiceItemID;
    saveReq.AdmissionServiceItemCode = val.AdmissionServiceItemCode;
    saveReq.TreatmentCategory = val.TreatmentCategory;
    saveReq.Remarks = val.Remarks;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40172;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          // then refresh
          this.LoadAdmissionServices();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  AddCategory() {
    var AdmissionService = new AdmissionServiceDetail();

    AdmissionService.AdmissionNo = this.SelectedAdmission.AdmissionCode;
    AdmissionService.AdmissionDate = this.SelectedAdmission.AdmissionDate;
    AdmissionService.CareUnit = this.SelectedAdmission.CareUnit;
    AdmissionService.BedLocation = this.SelectedAdmission.BedLocation;
    AdmissionService.PatientName = this.SelectedAdmission.PatientName;
    AdmissionService.TreatmentCategory = this.TreatmentCategory;
    AdmissionService.PatientFormattedCode = this.SelectedAdmission.PatientFormattedCode;
    AdmissionService.BranchName = AppData.Instance().UserLoginDetails.FacilityName;
    AdmissionService.BranchCode = AppData.Instance().SelectedFacilityCode;
    const modalRef = this.modalService.open(NgbCategoryChangeModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false

      })
    modalRef.componentInstance.AdmissionService = AdmissionService;
    modalRef.result.then((val: AdmissionServiceDetail) => {
      this.ChangeTreatmentCategory(val);

    });
  }
  ChangeTreatmentCategory(val: AdmissionServiceDetail) {
    var saveReq = new SaveAdmissionTreatmentCategory();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40182;
    //saveReq.BranchCode = AppData.Instance().SelectedBranchCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.AdmissionNo = val.AdmissionNo;
    saveReq.TreatmentCategory = val.TreatmentCategory;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40182;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          // then refresh
          this.LoadTreatmentCategory();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  DeleteMaterial(l: AdmissionServiceDetail) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteMaterial2(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteMaterial2(l: AdmissionServiceDetail) {
    var saveReq = new DeletedAdmissionServiceRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40220;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.ActionTag = "Delete";
    saveReq.BranchCode = l.BranchCode;
    saveReq.ServiceCode = l.ServiceCode;
    saveReq.AdmissionNo = l.AdmissionNo;
    saveReq.AdmissionServiceItemID = l.AdmissionServiceItemID;
    saveReq.AdmissionServiceItemCode = l.AdmissionServiceItemCode;
    saveReq.TreatmentCategory = l.TreatmentCategory;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40220;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.LoadAdmissionServices();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
   
  
}
